import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import DropdownSearch from "../../common/DropdownSearch";

import DragAndDropContainer from "./DragAndDropContainer";
import SupportResourcesInfoHeader from "./SupportResourcesInfoHeader";
import SupportResourcesAddButton from "./SupportResorcesAddButton";

const SupportResources = ({
  resources,
  onChange,
  onChangeSupportResources,
  showTicketAssignmentStyle,
  showHeader,
  ticketAssignmentStyle,
  ticketAssignmentStyleOptions,
  employeeOptions,
  isNightMode,
  disabled,
  contentStyle,
  projectId
}) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (resources.length) {
      setItems(resources);
    }
  }, [resources]);

  const onDragEnd = (result) => {
    const { destination, source } = result;

    if (!destination) {
      return;
    }

    if (!items[destination.index].employee || !items[source.index].employee) {
      return;
    }

    const reorderedItems = Array.from(items);
    const [removed] = reorderedItems.splice(source.index, 1);
    reorderedItems.splice(destination.index, 0, removed);

    const updatedItems = reorderedItems.map((item, index) => ({
      ...item,
      id: (index + 1).toString(),
      text: index + 1
    }));

    setItems(updatedItems);
    onChangeSupportResources(updatedItems);
  };

  const removeItem = (id) => {
    if (items.length > 1) {
      const updatedItems = items
        .filter((item) => item.id !== id)
        .map((item, index) => ({
          ...item,
          id: (index + 1).toString(),
          text: index + 1
        }));

      setItems(updatedItems);
      onChangeSupportResources(updatedItems);
    }
  };

  const addItem = () => {
    if (!items.some((item) => !item.employee)) {
      const newId = (
        Math.max(...items.map((item) => parseInt(item.id))) + 1
      ).toString();
      const newItem = { id: newId, text: newId };
      setItems([...items, newItem]);
      onChangeSupportResources([...items, newItem]);
    }
  };

  const handleEmployeeChange = (employee, index) => {
    if (!items.some((item) => item.employee === employee.value)) {
      const updatedItems = items.map((item, i) =>
        i === index - 1 ? { ...item, employee: employee?.value || "" } : item
      );
      setItems(updatedItems);
      onChangeSupportResources(updatedItems);
    }
  };

  return (
    <div style={{ marginTop: 0, marginRight: 0, marginBottom: 0 }}>
      {showHeader && (
        <fieldset>
          <legend className="flex -space-between" style={{ margin: 0 }}>
            <span style={{ margin: 0, display: "flex", height: "22px" }}>
              <span style={{ margin: 0, fontSize: "16px" }}>
                Support Resources
              </span>
              <SupportResourcesInfoHeader isNightMode={isNightMode} />
            </span>
            <SupportResourcesAddButton
              isNightMode={isNightMode}
              disabled={disabled}
              items={items}
              addItem={addItem}
              id={projectId}
            />
          </legend>
        </fieldset>
      )}
      <div style={contentStyle}>
        {showTicketAssignmentStyle && (
          <div style={{ marginLeft: 15, marginRight: 15 }}>
            <DropdownSearch
              required={items.some((item) => item.employee)}
              rowStyles={{ marginTop: 0 }}
              rowClassNames=""
              name="ticketAssignmentStyle"
              label="Assignment Style"
              onChange={onChange}
              value={ticketAssignmentStyle}
              data={ticketAssignmentStyleOptions}
              disabled={disabled}
            />
          </div>
        )}

        <div style={{ display: "flex" }}>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              overflowX: "hidden",
              overflowY: "auto",
              maxHeight: 190
            }}
          >
            <DragAndDropContainer
              items={items}
              onDragEnd={onDragEnd}
              removeItem={removeItem}
              onEmployeeChange={handleEmployeeChange}
              employeeData={employeeOptions.map((i) => ({
                ...i,
                disabled: true
              }))}
              isNightMode={isNightMode}
              disabled={disabled || !ticketAssignmentStyle}
            />
          </div>
          {!showHeader && (
            <div style={{ alignSelf: "center" }}>
              <SupportResourcesAddButton
                isNightMode={isNightMode}
                disabled={disabled}
                items={items}
                addItem={addItem}
                id={projectId}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

SupportResources.propTypes = {
  resources: PropTypes.array,
  onChange: PropTypes.func,
  onChangeSupportResources: PropTypes.func,
  showTicketAssignmentStyle: PropTypes.bool,
  showHeader: PropTypes.bool,
  ticketAssignmentStyle: PropTypes.string,
  ticketAssignmentStyleOptions: PropTypes.array,
  employeeOptions: PropTypes.array,
  isNightMode: PropTypes.bool,
  disabled: PropTypes.bool,
  contentStyle: PropTypes.object,
  projectId: PropTypes.string
};

SupportResources.defaultProps = {
  resources: [{ id: 1, employee: "", text: 1 }],
  showTicketAssignmentStyle: true,
  showHeader: true,
  contentStyle: {
    borderRadius: "0 0 4px 4px",
    border: `1px solid #50accb`,
    padding: "1.5rem",
    maxHeight: 500
  },
  projectId: "id"
};

export default SupportResources;
